<template>
	<search-group
  @search="findData"
  @clear="clearValue"
  :span="24"
  :inline="true"
  :btnOffset="20"
  >
		<Row class="mb16" :gutter="16">
			<Col span="6">
        <Select v-model="searchData.projectFid" placeholder="项目名称" @on-change="change">
<!--          <Option value=''>请选择</Option>-->
          <Option v-for="(item,index) in projectList" :key="'s1'+index" :value="item.value">{{item.text}}</Option>
        </Select>
      </Col>
			<Col span="6">
				<Input v-model="searchData.customerInfo" placeholder="姓名、手机号、身份证号" :maxlength="50"></Input>
			</Col>
			<!-- <Col span="5">
        <Select v-model="searchData.projectFid" placeholder="商机状态" >
          <Option value=''>请选择</Option>
          <Option v-for="(item,index) in businessStatus" :key="'s2'+index" :value="item.value">{{item.text}}</Option>
        </Select>
      </Col> -->
			<!-- <Col span="5">
        <Select v-model="searchData.projectFid" placeholder="合同状态" >
          <Option value=''>请选择</Option>
          <Option v-for="(item,index) in projectList" :key="'s2'+index" :value="item.value">{{item.text}}</Option>
        </Select>
      </Col> -->

			 <Col span="6">
        <Select v-model="searchData.salaryRange" placeholder="薪资范围" >
          <Option value=''>请选择</Option>
          <Option v-for="(item,index) in salaryRangeList" :key="'s3'+index" :value="item.value">{{item.text}}</Option>
        </Select>
      </Col>
		</Row>
		<Row class="mb16" :gutter="16">

      <Col span="6">
        <Select v-model="searchData.budgetRange" placeholder="预算范围" >
          <Option value=''>请选择</Option>
          <Option v-for="(item,index) in budgetRangeList" :key="'s4'+index" :value="item.value">{{item.text}}</Option>
        </Select>
      </Col>
      <Col span="6">
        <!-- <Select v-model="searchData.intentionAddress" placeholder="意向居住地点" >
          <Option value=''>请选择</Option>
          <Option v-for="(item,index) in intentionAddressList" :key="'s5'+index" :value="item.value">{{item.text}}</Option>
        </Select> -->
        <Cascader placeholder="意向居住地点" :data="regionList" trigger="hover" v-model="searchData.intentionAddressArr"></Cascader>
      </Col>
			<Col span="6">
        <Select v-model="searchData.intentionArea" placeholder="意向房型面积" >
          <Option value=''>请选择</Option>
          <Option v-for="(item,index) in intentionAreaList" :key="'s6'+index" :value="item.value">{{item.text}}</Option>
        </Select>
      </Col>

		</Row>
    <!-- <Row class="mb16"  :gutter="16">
      <Col span="6">
        <DatePicker style="width:100%" type="datetimerange" placeholder="签约日范围" format="yyyy-MM-dd" v-model="searchData.createTime"></DatePicker>
      </Col>
			<Col span="6">
        <DatePicker style="width:100%" type="datetimerange" placeholder="到期日范围" format="yyyy-MM-dd" v-model="searchData.createTime"></DatePicker>
      </Col>
			<Col span="6">
        <DatePicker style="width:100%" type="datetimerange" placeholder="带看时间范围" format="yyyy-MM-dd" v-model="searchData.createTime"></DatePicker>
      </Col>
    </Row> -->
	</search-group>
</template>

<script>
import SearchGroup from 'components/SearchGroup/index';
import { formatDateTime } from "../../../../utils/format";
import {getAreaRegionByProjectFid} from 'api/business'
import {getProjects} from "../../../../api/common";

export default {
	components:{
		SearchGroup,
  },
  props:{
    // projectList:{
    //   type:Array,
    //   default(){
    //     return []
    //   }
    // },
    businessStatus:{
      type:Array,
      default(){
        return []
      }
    },
    intentionAreaList:{
      type:Array,
      default(){
        return []
      }
    },
    salaryRangeList:{
      type:Array,
      default(){
        return []
      }
    },
    budgetRangeList:{
      type:Array,
      default(){
        return []
      }
    },
    intentionAddressList:{
      type:Array,
      default(){
        return []
      }
    }
  },
	data(){
		return{
      projectList:[],
      searchData:{
        // intentionAddressArr:[]
        projectFid:'',
        customerInfo:'',
        salaryRange:'',
        budgetRange:'',
        intentionAddressArr:[],
        intentionArea:''
      },
      regionList:[],
		}
  },
  computed:{
    searchParams(){
      if(this.searchData.intentionAddressArr.length>0){
        if(this.searchData.intentionAddressArr[0]){
          this.searchData.intentionAddressCity = this.searchData.intentionAddressArr[0]
        }
        if(this.searchData.intentionAddressArr[1]){
          this.searchData.intentionAddressArea = this.searchData.intentionAddressArr[1]
        }
        if(this.searchData.intentionAddressArr[2]){
          this.searchData.intentionAddress = this.searchData.intentionAddressArr[2]
        }
      } else{
        this.searchData.intentionAddressCity = '';
        this.searchData.intentionAddressArea = '';
        this.searchData.intentionAddress = ''
      }

      return{
        projectFid:this.searchData.projectFid,
        customerInfo:this.searchData.customerInfo,
        salaryRange:this.searchData.salaryRange,
        budgetRange:this.searchData.budgetRange,
        intentionAddress:this.searchData.intentionAddress,
        intentionAddressCity:this.searchData.intentionAddressCity,
        intentionAddressArea:this.searchData.intentionAddressArea,
        intentionArea:this.searchData.intentionArea
      }

    }
  },
  created(){
    getProjects().then( res => {
      this.projectList = res.data||[];
      if(this.projectList.length){
        this.searchData.projectFid=this.projectList[0].value
        this.$emit('search',this.searchParams)
        this.getRegion(this.searchParams.projectFid)
      }
    }).catch(error=>{});

  },
	methods:{
    change(val){
      this.getRegion(val)
      this.searchParams.intentionAddressArr = []
    },
		findData(){
      this.$emit('search',this.searchParams)
    },
    getRegion(fid){
			getAreaRegionByProjectFid({projectFid:fid}).then( res=>{
				this.regionList = res.data;
			})
		},
		clearValue(){
      this.searchData = {
        projectFid:'',
        customerInfo:'',
        salaryRange:'',
        budgetRange:'',
        intentionAddressArr:[],
        intentionArea:''
      }
		}
	}
}
</script>

<style>

</style>
